function SignOut(callback) {
    try {
        $.post('api/authentication/logout', function () {

        }).always(function () {
            SignOutGatorLeads(callback);
        });
    } catch (e) {
        console.log(e);
    }
}

function SignOutGatorLeads(callback) {
    try {
        $.getScript("https://leads.communigator.co.uk/Account/LogOff?actionValue=ssoLogOff", function (data, textStatus, jqxhr) {
            $(".GatorLeads img").hide();
            $(".GatorLeads i").show();
        }).always(function () {
            SignOutGatorMail(callback);
        });
    } catch (e) {
    }
}

function SignOutGatorMail(callback) {
    try {
        $.getScript("https://gatormail.communigator.co.uk/default.aspx?action=logoff", function (data, textStatus, jqxhr) {
            $(".GatorMail img").hide();
            $(".GatorMail i").show();
        }).always(function () {
            SignOutTheGators(callback);
        });
    } catch (e) {
    }
}

function SignOutTheGators(callback) {
    try {
        $.getScript("https://guru.communigator.co.uk/default.aspx?action=logoff", function (data, textStatus, jqxhr) {
         
        }).always(function () {
            SignOutGatorWorkflow(callback);
        });
    } catch (e) {
    }
}

//function SignOutGatorExpress() {
//    try {
//        $.getScript("https://guru.communigator.co.uk/GatorExpress/api/Authentication/LogOut", function (data, textStatus, jqxhr) {
//            $(".GatorExpress img").hide();
//            $(".GatorExpress i").show();
//        }).always(function () {
//            SignOutGatorWorkflow();
//        });
//    } catch (e) {

//    }
//}

function SignOutGatorWorkflow(callback) {
    try {
        $.getScript("https://productservices.communigator.co.uk/GatorWorkflow/api/authentication/log_out", function () {
            $(".GatorWorkflow img").hide();
            $(".GatorWorkflow i").show();
        }).always(function () {
            SignOutGatorSocial(callback);
        });
    } catch (e) {

    }
}

function SignOutGatorSocial(callback) {
    try {
        $.getScript("https://gsocial.communigator.co.uk/auth/logout", function (data, textStatus, jqxhr) {
            $(".GatorSocial img").hide();
            $(".GatorSocial i").show();
        }).always(function () {
            SignOutPopup(callback);
        });
    } catch (e) {

    }
}

function SignOutPopup(callback) {
    try {
        $.getScript("https://popup.communigator.co.uk/Account/LogOff?actionValue=ssoLogOff", function (data, textStatus, jqxhr) {
            $(".GatorPopup img").hide();
            $(".GatorPopup i").show();
        }).always(function () {
            SignOutGatorSurvey(callback);
        });
    } catch (e) {
    }
}

function SignOutGatorSurvey(callback) {
    try {
        $.getScript("https://survey.communigator.co.uk/api/authentication/Logout", function (data, textStatus, jqxhr) {
            $(".GatorSurvey img").hide();
            $(".GatorSurvey i").show();
            if (typeof callback !== 'undefined')
                callback();
        });
    } catch (e) {
        
    }
    
}


//function SignOutReport() {
//    try {
//        $.getScript("https://popup.communigator.co.uk/request/api/LogOff?actionValue=ssoLogOff", function (data, textStatus, jqxhr) {
//            $(".GatorReport img").hide();
//            $(".GatorReport i").show();
//        }).always(function () {
//            SignOutGatorSurvey(callback);
//        });
//    } catch (e) {
//    }
//}